import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "code-part-1" }
const _hoisted_3 = {
  key: 0,
  class: "code-season"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "bottom-line" }
const _hoisted_8 = ["placeholder", "maxlength"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_10 = ["maxlength"]
const _hoisted_11 = {
  key: 0,
  class: "spacer"
}
const _hoisted_12 = {
  key: 1,
  class: "special-code"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_17 = ["placeholder", "maxlength"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1)
const _hoisted_19 = ["maxlength"]
const _hoisted_20 = {
  key: 0,
  class: "spacer"
}
const _hoisted_21 = {
  key: 1,
  class: "special-code"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "code-season"
}
const _hoisted_25 = ["textContent"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_27 = ["textContent"]

import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  PropType,
} from 'vue';
import { ECarType, EPlateType, IOrderData, MonthShortMap } from '@/classes/interfaces/data';


export default /*#__PURE__*/_defineComponent({
  props: {
  Code1: { type: String, required: true },
  Code2: { type: String, required: true },
  Code3: { type: String, required: true },
  OrderData: { type: Object as PropType<IOrderData>, required: true },
},
  emits: ["update:Code2", "update:Code3", "enter"],
  setup(__props, { expose, emit }: { emit: ({
  (e: 'update:Code2', value: string): void;
  (e: 'update:Code3', value: string): void;
  (e: 'enter'): void;
}), expose: any, slots: any, attrs: any }) {

const Props = __props

const Code2Internal = ref<string>('');
const Code3Internal = ref<string>('');
const Scale = ref<number>(1);
const Height = ref<number>(0);
const WrapElement = ref<HTMLElement>();
const LicenseElement = ref<HTMLElement>();




const BaseMaxLength = computed(() => {
  if (Props.OrderData.carType == ECarType.MotorCycle) {
    let Length = 5 + Props.Code1.length;

    if (
      Props.OrderData.plateType == EPlateType.Electric ||
      Props.OrderData.plateType == EPlateType.OldTimer
    ) {
      Length -= 1;
    }
    return Length;
  } else {
    let Length = 8;

    if (Props.OrderData.isSeason == true) {
      Length -= 1;
    }

    if (
      Props.OrderData.plateType == EPlateType.Electric ||
      Props.OrderData.plateType == EPlateType.OldTimer
    ) {
      Length -= 1;
    }

    return Length;
  }
});

const MaxLenght2 = computed(() => {
  return Math.min(2, BaseMaxLength.value - Props.Code1.length - Code3Internal.value.length);
});
const Code2Error = computed(() => {
  const ForbiddenCodes = ['HJ', 'KZ', 'NS', 'SA', 'SS', 'IS'];

  return ForbiddenCodes.indexOf(Code2Internal.value.toUpperCase()) > -1;
});
const MaxLenght3 = computed(() => {
  const BaseMaxLength3 = Props.OrderData.carType == ECarType.MotorCycle ? 3 : 4;
  return Math.min(
    BaseMaxLength3,
    BaseMaxLength.value - Props.Code1.length - Code2Internal.value.length,
  );
});

const ValidateInput = () => {
  Code2Internal.value = Code2Internal.value.replace(/[^a-zA-Z ]/g, '');
  Code3Internal.value = Code3Internal.value.replace(/\D/g, '');

  if (Code3Internal.value.length > MaxLenght3.value) {
    Code3Internal.value = Code3Internal.value.substring(0, MaxLenght3.value);
  }
  if (Code2Internal.value.length > MaxLenght2.value) {
    Code2Internal.value = Code2Internal.value.substring(0, MaxLenght2.value);
  }

  emit('update:Code2', Code2Internal.value);
  emit('update:Code3', Code3Internal.value);
};

const SetSize = () => {
  if (typeof WrapElement.value === 'undefined' || typeof LicenseElement.value === 'undefined') {
    return;
  }

  Scale.value = WrapElement.value.clientWidth / LicenseElement.value?.clientWidth;

  Height.value = LicenseElement.value?.clientHeight * Scale.value;

  console.log(Height.value);
  if (Height.value > 330) {
    Scale.value = 330 / LicenseElement.value?.clientHeight;
    Height.value = 330;
  }
};

onMounted(() => {
  Code2Internal.value = Props.Code2;
  Code3Internal.value = Props.Code3;

  window.addEventListener('resize', SetSize);
  SetSize();
});

onUnmounted(() => {
  window.removeEventListener('resize', SetSize);
});

expose({ SetSize, ValidateInput });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "license-input-wrap",
    ref: (_value, _refs) => {
      _refs['WrapElement'] = _value
      WrapElement.value = _value
    },
    style: _normalizeStyle({ height: `${Height.value}px` })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["license-input", `cartype-${__props.OrderData.carType}`]),
      ref: (_value, _refs) => {
        _refs['LicenseElement'] = _value
        LicenseElement.value = _value
      },
      style: _normalizeStyle({ transform: `scale(${Scale.value})` })
    }, [
      (__props.OrderData.carType == _unref(ECarType).MotorCycle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.Code1), 1),
            (__props.OrderData.isSeason)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (__props.OrderData.seasonStart != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        textContent: _toDisplayString(_unref(MonthShortMap)[__props.OrderData.seasonStart])
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true),
                  _hoisted_5,
                  (__props.OrderData.seasonEnd != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        textContent: _toDisplayString(_unref(MonthShortMap)[__props.OrderData.seasonEnd])
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: _unref(MaxLenght2) == 1 ? 'A' : 'AB',
                class: _normalizeClass(["code-part-2", {
              'length-0': __props.Code2.length == 0,
              'length-1': __props.Code2.length == 1,
              'length-2': __props.Code2.length == 2,
              'code1-3': __props.Code1.length == 3,
              highlighted: __props.Code2.length == 0,
              short: _unref(MaxLenght2) == 1,
              invalid: _unref(Code2Error),
            }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Code2Internal).value = $event)),
                maxlength: _unref(MaxLenght2),
                onKeyup: ValidateInput,
                onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('enter')), ["enter"]))
              }, null, 42, _hoisted_8), [
                [_vModelText, Code2Internal.value]
              ]),
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "12",
                class: _normalizeClass(["code-part-3", {
              'length-0': __props.Code3.length == 0,
              'length-1': __props.Code3.length == 1,
              'length-2': __props.Code3.length == 2,
              'length-3': __props.Code3.length == 3,
              highlighted: __props.Code2.length > 0 && __props.Code3.length == 0,
            }]),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((Code3Internal).value = $event)),
                maxlength: _unref(MaxLenght3),
                onKeyup: ValidateInput,
                onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (emit('enter')), ["enter"]))
              }, null, 42, _hoisted_10), [
                [_vModelText, Code3Internal.value]
              ]),
              (__props.OrderData.plateType != _unref(EPlateType).Default)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true),
              (__props.OrderData.plateType != _unref(EPlateType).Default)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (__props.OrderData.plateType == _unref(EPlateType).Electric)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "E"))
                      : _createCommentVNode("", true),
                    (__props.OrderData.plateType == _unref(EPlateType).OldTimer)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "H"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(["code-part-1", `length-${_unref(BaseMaxLength)}-${__props.Code1.length}`])
            }, _toDisplayString(__props.Code1), 3),
            _hoisted_16,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: _unref(MaxLenght2) == 1 ? 'A' : 'AB',
              class: _normalizeClass(["code-part-2", {
            'length-0': __props.Code2.length == 0,
            'length-1': __props.Code2.length == 1,
            'length-2': __props.Code2.length == 2,
            'length-3': __props.Code2.length == 3,
            'code1-3': __props.Code1.length == 3,
            highlighted: __props.Code2.length == 0,
            short: _unref(MaxLenght2) == 1,
            invalid: _unref(Code2Error),
          }]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((Code2Internal).value = $event)),
              maxlength: _unref(MaxLenght2),
              onKeyup: ValidateInput,
              onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (emit('enter')), ["enter"]))
            }, null, 42, _hoisted_17), [
              [_vModelText, Code2Internal.value]
            ]),
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "123",
              class: _normalizeClass(["code-part-3", {
            'length-0': __props.Code3.length == 0,
            'length-1': __props.Code3.length == 1,
            'length-2': __props.Code3.length == 2,
            'length-3': __props.Code3.length == 3,
            'length-4': __props.Code3.length == 4,
            highlighted: __props.Code2.length > 0 && __props.Code3.length == 0,
          }]),
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((Code3Internal).value = $event)),
              maxlength: _unref(MaxLenght3),
              onKeyup: ValidateInput,
              onKeydown: _cache[7] || (_cache[7] = _withKeys(($event: any) => (emit('enter')), ["enter"]))
            }, null, 42, _hoisted_19), [
              [_vModelText, Code3Internal.value]
            ]),
            (__props.OrderData.isSeason || __props.OrderData.plateType != _unref(EPlateType).Default)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20))
              : _createCommentVNode("", true),
            (__props.OrderData.plateType != _unref(EPlateType).Default)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (__props.OrderData.plateType == _unref(EPlateType).Electric)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "E"))
                    : _createCommentVNode("", true),
                  (__props.OrderData.plateType == _unref(EPlateType).OldTimer)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "H"))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (__props.OrderData.isSeason)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (__props.OrderData.seasonStart != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        textContent: _toDisplayString(_unref(MonthShortMap)[__props.OrderData.seasonStart])
                      }, null, 8, _hoisted_25))
                    : _createCommentVNode("", true),
                  _hoisted_26,
                  (__props.OrderData.seasonEnd != null)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        textContent: _toDisplayString(_unref(MonthShortMap)[__props.OrderData.seasonEnd])
                      }, null, 8, _hoisted_27))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
    ], 6)
  ], 4))
}
}

})